export const AREAS_EQUIPAMENTO = Object.freeze([
  "OPERAÇÃO", "ADMINISTRAÇÃO", "TOPOGRAFIA", "OFICINA", "LABORATÓRIO"
])

const chave = valor => valor.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
export function normalizarAreaEquipamento(valor) {
  if (valor === undefined || valor === null || valor === "") return null
  if (typeof valor === "string" && !valor.trim()) return null
  const area = typeof valor === "string" && AREAS_EQUIPAMENTO.find(a => chave(a) === chave(valor))
  if (!area) throw Object.assign(new Error(`Selecione uma área válida: ${AREAS_EQUIPAMENTO.join(", ")}`), { status: 400 })
  return area
}

export function areaParaFormulario(valor) {
  try { return normalizarAreaEquipamento(valor) || "" }
  catch { return valor } // Exibe o valor legado sem modificar cadastros ou histórico.
}
